// 引入vue-amap
import VueAMap from 'vue-amap'
import Vue from "vue";

Vue.use(VueAMap)


// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 高德的key
    key: '1d5b1a71d19f391ecf8e4f2770fe7e7b',
    // 插件集合
    plugin: [
        'AMap.CircleEditor',// 圆形编辑器插件
        "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
        "AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
        "AMap.Autocomplete",
        "AMap.PlaceSearch",
        "AMap.CitySearch",
        "AMap.Scale",
        "AMap.HawkEye",
        "AMap.ToolBar",
        "AMap.ControlBar",
        "AMap.MouseTool",
        "AMap.DragRoute",
        "AMap.MoveAnimation"
    ],
    // 高德 sdk 版本，默认为 1.4.4
    v: '1.4.4'
});
//高德的安全密钥
window._AMapSecurityConfig = {
    securityJsCode:'48a1ea670fdfa88f039b9f4e70f4e488',
}